import { createSlice } from '@reduxjs/toolkit';
import {query, describe} from '../../services/salesforce'

export const registerSlice = createSlice({

    // Slice name, this should be always as page name.
    name: 'register',

    // Initial state for the slice
    initialState: {
        data: {},
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null
    },

    // Reducers will mutate the state, put all the state mutation method over here 
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = 'succeeded';
            state.error = null;
        },
        error: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
    },
})

export default registerSlice.reducer

// Export all the reducers actions here
export const { initialize, error } = registerSlice.actions;


// Public Selectors
export const selectRegisterData = (state) => state.register.data;
export const selectRegisterStatus = (state) => state.register.status;
export const selectRegisterError = (state) => state.register.error;

export const initializeAsync = (props) => async (dispatch) => {
    // const result = await query('account');
    // if(result.isSuccess){
    //     dispatch(initialize({records: result.data}));
    // }
    // else{
    //     dispatch(error(result.errorMessage))
    // }

    dispatch(initialize({}));
}

